import Utils from '../common/Utils';
import Swiper from 'swiper';
import Popularity from '../index/homePopularity';
import Myfeed from '../index/homeMyfeed';
import PromotionSlick from '../component/promotionSlick';
import Promotion from '../component/promotion';
import News from '../component/news';
import Shortcut from '../component/shortcut';
import Appdown from '../component/appdown';
import Cmazit from '../component/cmazit';
import Cmbest from '../component/cmbest';
import Movie from '../component/movie';
import Guide from '../component/guide';
import {GLOBAL_PATH, STORE, TAB} from '../common/Model';
import {communityHomeL10n} from "../common/L10n";

class App {
	constructor(_config = {}) {
		const htmlEl = document.getElementsByTagName("html")[0];
		this.config = _config;
		this.config.service = htmlEl.getAttribute('data-service').toLowerCase() || 'tricksterm'; // service = tricskterm, h3, bns2, linw, l2mru
		this.config.country = window._localeCountry ? window._localeCountry : 'KR'; // kr hk
		this.config.lang = htmlEl.getAttribute('lang').toLowerCase() || 'ko'; // 'ko-KR';
		this.config.locale = window._locale ? window._locale : window.userData.locale; // 'ko-KR';
		this.config.isRtl = document.querySelectorAll("html[dir=rtl]").length > 0;
		this.config.isDarkmode = document.querySelectorAll("html[class=dark-mode]").length > 0;
		this.config.tabCookieName = `${this.config.service.toUpperCase()}_MyTab`; // 탭 쿠키 명 , 쿠키 체크해서 진입할 때 기존 열었던 탭을 보여주려 함

		this.config.isGlobal = (this.config.service === 'lineagew' || this.config.service==='lineage2mru' || this.config.service==='lineage2mnaeu'); // 커뮤니티 글로벌 API 사용 여부 및 마이피드 url에서 국가 패스 유무
		this.config.isConti = (this.config.service != 'lineagew' ); // 콘티 유무

		this.isPopularity = _config.tabConfig.tabActive.popularity || false; // 인기탭 활성화 여부 {\"tabActive\":{\"popularity\":false,\"myfeed\":true},\"tabPopularity\":{\"list\":[{\"isActive\":false}]}
		this.isMyfeed = _config.tabConfig.tabActive.myfeed || false; // 마이 탭 활성화 여부
		// this.isCmpickChannel = _config.tabConfig.tabActive.cmpickChannel;
		this.isCmpickGuidebook = _config.tabConfig.tabActive.cmpickGuidebook;
		this.isMobile = false;
		this.l10n = communityHomeL10n[this.config.lang];

		// cookie
		const lang = htmlEl.getAttribute('lang')? htmlEl.getAttribute('lang').toLocaleLowerCase(): 'ko';
		this.isCookieApply = false;
		if (lang ==='ko' || this.config.service !== 'lineagew' || this.config.service !== 'lineage2mru' || this.config.service !== 'lineage2mnaeu' || this.config.service ==='lineage2mnct' || this.config.service ==='lineage2mncj') { // 글로벌 서비스에서만 적용됨
			this.isCookieApply = true;
		} else {
			this.isCookieApply = JSON.parse(decodeURIComponent(Utils.getCookie('applyCookie')));
			this.isCookieApply = this.isCookieApply?.typeArr?.indexOf('FUNCTIONAL');
			this.isCookieApply = (this.isCookieApply !== undefined) && (this.isCookieApply > -1);
		}
		// console.log('=>COOKIE? this.isCookieApply : ', this.isCookieApply );
		// console.log( '=> this.config : ', this.config);
		this.init(this.config);
	}

	init(_config) {
		this.isMobile = document.querySelectorAll("body[class=mobile]").length > 0;
		if (this.isPopularity || this.isMyfeed) {
			this.tabEvent(_config);
		} else {
			document.querySelector(`[data-content-id="cmpick"]`).classList.add('is-active');
		}

		this.render(_config);

		// conti separate
		if(this.config.isConti) { // if conti
			this.getGroup();
		} else { // LW

			new PromotionSlick(this.config).init();

			this.newsToggleEvent();
			this.shortcutEvent();

			new Cmazit(this.config).init();
			if(this.isCmpickGuidebook ) new Guide(this.config).init();
			// new Pwa(this.config).init();
			new Cmbest(this.config).init();
			// if(this.isCmpickChannel ) new Channel(this.config).init();
			new Movie(this.config).init();
		}
	}

	getGroup() { // if conti
		const _this = this;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'group',
			locale : this.config.locale,
			country : this.config.country
		};
		this.groupUrl = GLOBAL_PATH(_option);
		// console.log( '#getGroup: _option: ', _option, this.groupUrl);

		fetch(this.groupUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			// console.log(data);
			let setGroup = async () => {
				data.forEach(item => {
					if(item.alias === 'nchome-promotion') STORE.data.promotion = JSON.parse(item.jsonData);
					if(item.alias === 'nchome-news') STORE.data.news = JSON.parse(item.jsonData).list;
					if(item.alias === 'nchome-shortcut') STORE.data.shortcut = JSON.parse(item.jsonData);
					if(item.alias === 'nchome-appdown') STORE.data.appdown = JSON.parse(item.jsonData);
					if(item.alias === 'nchome-cmpick-azit') STORE.data.cmazit = JSON.parse(item.jsonData);
					if(item.alias === 'nchome-cmpick-best') STORE.data.cmbest = JSON.parse(item.jsonData);
				});
			};
			setGroup().then(() => {
				new PromotionSlick(_this.config).init();
				new News(_this.config).init();
				new Shortcut(_this.config).init();
				new Appdown(_this.config).init();
				new Cmazit(_this.config).init();
				if(_this.isCmpickGuidebook ) new Guide(_this.config).init();
				new Movie(_this.config).init();
				new Cmbest(_this.config).init();
				if(document.querySelectorAll('.home-loading').length > 0 ) document.querySelector('.home-loading').remove(); // loading
			});

		}).catch(function (err) { // There was an error
			console.warn('Something went wrong.', err);
		});

	}
	// tab
	tabEvent(_config) {
		const _this = this;
		const tabContainer = document.querySelector('.home-tab');
		const tabParent = document.querySelector('.tab-list');
		const tabs =  document.querySelectorAll('.tab-item');
		const contentParent = document.querySelector('.home-content');
		const contents =  document.querySelector('.home-content [data-content-id]');

		let prevTab_id;
		let activeTab_id = (_this.isCookieApply && Utils.getCookie(_this.config.tabCookieName)) ? Utils.getCookie(_this.config.tabCookieName) : TAB.CMPICK ; // cookie
		// console.log('=>COOKIE? this.isCookieApply / activeTab_id : ', _this.isCookieApply , activeTab_id );

		let activeTab_object = document.querySelector(`[data-tab-id="${activeTab_id}"]`);
		let activeContent_object = document.querySelector(`[data-content-id="${activeTab_id}"]`);

		activeTab_object.classList.add('is-active');
		activeContent_object.classList.add('is-active');
		tabContainer.setAttribute('data-active-tab-id',activeTab_id);

		prevTab_id = activeTab_id;

		if(this.isPopularity ) new Popularity(_config).init();
		if(this.isMyfeed ) new Myfeed(_config).init();

		tabs.forEach((el) => {
			el.addEventListener('click', (evt) => {

				evt.preventDefault();
				activeTab_id = el.getAttribute('data-tab-id');

				if( prevTab_id == activeTab_id ) {
					return false;
				}

				document.querySelector(`[data-tab-id="${prevTab_id}"]`).classList.remove('is-active');
				document.querySelector(`[data-content-id="${prevTab_id}"]`).classList.remove('is-active');

				activeTab_object = document.querySelector(`[data-tab-id="${activeTab_id}"]`);
				activeContent_object = document.querySelector(`[data-content-id="${activeTab_id}"]`);

				activeTab_object.classList.add('is-active');
				activeContent_object.classList.add('is-active');

				tabContainer.setAttribute('data-active-tab-id', activeTab_id);

				prevTab_id = activeTab_id;

				if(_this.isCookieApply) { // cookie
					Utils.setCookie(_this.config.tabCookieName, activeTab_id, 1);
					// console.log('=>COOKIE? activeTab_id : ', activeTab_id);
				}

			});
		});

	} // tabEvent

	render(_config) {
		const _container = $('.home-cmpick');

		if( _container.is(':empty') ) {
			let containerTmpl = `
			<section class="cmazit-wrapper"></section>
			<section class="guide-wrapper"></section>
			<section class="cmbest-wrapper"></section>
			<section class="movie-wrapper"></section>
			`;
			_container.html(containerTmpl);

		}
	}

	// news
	newsToggleEvent() {
		let parent = document.querySelector('.news-wrapper');
		let button = document.querySelector('.news-wrapper .news-button');
		let flag;
		button.addEventListener('click', (evt) => {
			evt.preventDefault();
			if(! flag) {
				parent.classList.add('is-active');
				flag = true;
			}else {
				parent.classList.remove('is-active');
				flag = false;
			}
		});
	}

	// shortcut Mobile
	shortcutEvent() {
		let topShortcutSwiper = new Swiper('#topShortcut', {
			slidesPerView: 'auto'
		});
		let bottomShortcutSwiper = new Swiper('#bottomShortcut', {
			slidesPerView: 'auto'
		});
	}




}

Utils.namespace('nc.communityHome');
nc.communityHome = App;